let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ins06")).then(() => parcelRequire('20uOS'));